import './Stylesheets/Main.scss';

import $ from 'jquery';
import Slider from './Modules/Vendor/Slider/Slider';
import SlideMode from './Modules/Vendor/Slider/Types/SlideMode';
import SliderMode from './Modules/Vendor/Slider/Types/SliderMode';
import Lightbox from './Modules/Vendor/Lightbox';

window.$ = $;
window.jQuery = $;

document.addEventListener('DOMContentLoaded', () :void => {

    if (window.cookiePopupEnable) {
        import('./Modules/CookiePopup.js');
    }

    if (window.dropDownMenuEnable) {
        import('./Modules/DropDownMenu.js');
    }

    const isMobile = window.matchMedia('(max-width: 767px)').matches;

    const articleDetailView = document.getElementById('detailview')
    if (articleDetailView) {
        const articleDetailViewMedia = articleDetailView.querySelector('.article__media')
        if (articleDetailViewMedia) {
            const articleDetailViewImages = articleDetailViewMedia.querySelectorAll('.article__media__image')
            if (1 < articleDetailViewImages.length && isMobile) {
                new Slider(articleDetailViewMedia, {
                    mode: Slider.MODE_SLIDE as SliderMode,
                    debug: false,
                    controls: false,
                    navigation: true,
                    itemSelector: '.article__media__image',
                    autoplayIndicator: false
                })
            }
        }
    }

    window.addEventListener('scroll', () => {
        if (window.scrollY >= 100) {
            document.body.classList.add('-scrolled-down')
            return
        }
        document.body.classList.remove('-scrolled-down')
    })
    window.dispatchEvent(new Event('scroll'))

    new Lightbox({
        debug: false,
        title: true,
        titleCallback: (element) => {
            return element.parentNode.querySelector('.article__media__image__caption')?.textContent || null
        },
        maxContentWidth: 1024
    })

    var categorySelector = $('.tx-wwpreset-selectCategory'),
        elements = $('article, .article-group, .content-element'), // All Content Elements
        headerSlideshow = $('#page-header-images'),
        menu = $('#menu'),
        menuHoverables = $('#menu-nav ul li, #footer-sitemap ul li'),
        menuToggles = $('#menu-dismiss, #menu-icon, #search-icon'),
        resizeDelay = false,
        searchInput = $('#menu-search input'),
        searchResults = $('#menu-search-results'),
        searchSubmit = $('#menu-search button'),
        shareButtons = $('.share-button'),
        tiles = $('.tile');

    // Highlighting of elements
    const highlightElements = window.location.hash ? document.querySelectorAll(`${window.location.hash}, [data-translation-id="${window.location.hash.replace('#', '')}"]`)[0] || null : null;
    const fadeElements = $('main > *');
    if (null !== highlightElements && window.location.hash) {
        fadeElements.not(highlightElements).not($(highlightElements).parents()).addClass('fade');
        $(window).on('click', function () {
            fadeElements.removeClass('fade');
        });
        setTimeout(function () {
            fadeElements.removeClass('fade');
        }, 10000);
    }

    // Button Width
    elements.each(function () {
        if (!$(this).is('#detailview') && $(this).find('.button').length > 0 && $(this).find('.share-button').length === 0) {
            $(this).find('.button').addClass('full');
        }
    });

    // Slideshow
    if (headerSlideshow.length) {
        headerSlideshow.find('.slideshow-item').each((i, item) => {
            if (
                (item.classList.contains('slideshow-item--mobile') && !isMobile) ||
                (item.classList.contains('slideshow-item--non-mobile') && isMobile)
            ) {
                item.remove();
            }
        });
        new Slider(headerSlideshow[0], {
            itemSelector: '.slideshow-item',
            slideMode: Slider.SLIDE_MODE_ROTATE as SlideMode,
            controls: headerSlideshow.find('.slideshow-item').length > 1,
            autoplay: headerSlideshow.find('.slideshow-item').length > 1,
            autoplayIndicator: false
        });
    }

    // ##############
    // Article groups
    // ##############

    const articleGroupSliders = document.querySelectorAll('.article-group-slider');
    if (articleGroupSliders.length) {
        articleGroupSliders.forEach(articleGroupSlider => {
            articleGroupSlider.style.setProperty('overflow-y', 'hidden');
            new Slider(
                articleGroupSlider,
                {
                    controls: true,
                    itemSelector: '.slideshow-item',
                    slideMode: Slider.SLIDE_MODE_ROTATE,
                    transitionDuration: 300,
                    onSlide: () => {
                        articleGroupSliderUpdateHeight(articleGroupSlider);
                    }
                }
            );
        });
    }

    function articleGroupSliderUpdateHeight (slider, sharing=false) {
        const currentArticle = slider.querySelector('.slideshow-item--current') || slider.querySelector('article:first-of-type');
        const currentArticleHeight = currentArticle.querySelector('div').scrollHeight;
        slider.style.setProperty('height', currentArticleHeight + 50 + 'px');
    }

    if (categorySelector.length) {
        categorySelector.on('change', function() {
            const ajaxContainer = this.parentNode.querySelector('.ajax-container');
            if ($(this).val() !== 0 || $(this).val() !== '0') {
                $(this).addClass('loading');
                $.ajax({
                    url: $(this).val(),
                    method: 'POST'
                })
                    .success(function(results) {
                        $(ajaxContainer).html(results);
                        categorySelector.removeClass('loading');
                    })
                    .error(function (error) {
                        console.log(error);
                    });
            }
        });
    }

    $(window).on('resize', windowResizeHandler).resize();
    menuHoverables.on('click', function () {
        if ($(this).find('ul').length) {
            $(this).toggleClass('active');
        }
    });
    menuToggles.on('click', function () {
        menu.toggleClass('visible');
        if ($(this).is('#search-icon') && menu.hasClass('visible')) {
            setTimeout(function () {
                searchInput.focus();
            }, 500);
        }
    });
    searchInput.on('change', function (e) {
        doSearch();
    });
    searchSubmit.on('click', function (e) {
        e.preventDefault();
        doSearch();
        return false;
    });

    // Share Functionality
    shareButtons.on('click', function () {
        const shareOptions = $(this).next('.share-options');
        const slider = $(this).parents('.article-group-slider');
        shareOptions.toggleClass('visible');
        setTimeout(() => {
            articleGroupSliderUpdateHeight(slider, shareOptions.hasClass('visible'));
        }, 1000);
    });

    // Copy image caption into link's title attribute for image links
    $('article#detailview a[href*=".jpg"]').each(function () {
        if (!$(this).attr('title')) {
            const imgCaption = $(this).next('.image__caption').text() || $(this).find('img').attr('title') || false;
            if (imgCaption) {
                $(this).attr('title', imgCaption);
            }
        }
    });

    // Automatically open external links in new tab/window
    $('a[href*="http"]').each(function () {
        var host = window.location.host;
        if (!$(this).is('[href*="' + host + '"]')) {
            $(this).attr('target', '_blank');
        }
    });

    /**
     * DO SEARCH
     * Does a search
     */
    function doSearch() {
        searchResults.html('').addClass('loading');
        const searchUrl = window.location.toString().split('#')[0];
        console.log(searchUrl);
        $.ajax({
            url: searchUrl,
            method: 'GET',
            data: {
                type: 1807,
                string: searchInput.val()
            }
        })
            .success(function (data) {
                setTimeout(function () {
                    searchResults.removeClass('loading');
                    searchResults.html(data);
                }, 1000);
            });
    }

    /**
     * WINDOW RESIZE HANDLER
     * Whenever the window size changes
     */
    function windowResizeHandler() {
        clearTimeout(resizeDelay);
        resizeDelay = setTimeout(
            function () {
                tiles.each(function () {
                    var width = $(this).innerWidth() - 2 * parseInt($(this).css('padding-right'));
                    $(this).height(width);
                });
            },
            500
        );
    }
})